
  
  <div class="previsions-container">
    <div class="header">
      <span>{{ 'HEADBAND.MODELE.MODAL.GRAPH.REAL_TIME_TITLE' | translate }}</span>
      <button [pTooltip]="tooltipContent" tooltipEvent="focus" class="info-button">?</button>
      <ng-template #tooltipContent>
        <div>
            <span> {{ 'HEADBAND.MODELE.MODAL.GRAPH.REAL_TIME_TOOLTIP' | translate }} </span>
        </div>
      </ng-template>
    </div>
    <div class="actions">
      <div class="controls">
        <div class="period-selection">
          <button [ngClass]="{ 'active': selectedPeriodDays === 15 }" class="period-btn" type="button" (click)="filterDataByPeriod(15, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.FIFTEEN' | translate }}</button>
          <button [ngClass]="{ 'active': selectedPeriodDays === 30 }" class="period-btn" type="button" (click)="filterDataByPeriod(30, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.THIRTY' | translate }}</button>
          <button [ngClass]="{ 'active': selectedPeriodDays === 365 }" class="period-btn" type="button" (click)="filterDataByPeriod(365, $event)">{{ currentYear }}</button>
          <button [ngClass]="{ 'active': selectedPeriodDays === 365*10 }" class="period-btn" type="button" (click)="filterDataByPeriod(365 * 10, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.TEN_YEAR' | translate }}</button>
        </div>
        <button pButton type="button" (click)="op.toggle($event)" class="curve-btn">
          <span class="color-circle-gradient"></span>
          {{ 'ADMIN.MODEL.COMPUTE.CURVE' | translate }}
          <i class="pi" [ngClass]="{'pi-chevron-down': !op.overlayVisible, 'pi-chevron-up': op.overlayVisible}"></i>
        </button>
        <p-overlayPanel #op [dismissable]="true">
          <div class="predictions">
            <span class="label-predi">{{ 'ADMIN.MODEL.COMPUTE.LEGEND' | translate }}</span>
            <ul>
              <li *ngFor="let prediction of predictionItems">
                <input type="checkbox" [(ngModel)]="prediction.selected" (change)="toggleDataset(prediction.label)" />
                <span class="color-circle" [ngClass]="getPredictionClass(prediction.label)"></span>
                {{ prediction.label }}
              </li>
              
            </ul>
          </div>
        </p-overlayPanel>
      </div>
      <div>
        <p-button icon="pi pi-ellipsis-v" [rounded]="true" (click)="onGraphActions($event)" [text]="true"></p-button>
        <p-overlayPanel #graphActionsTemplate>
          <div class="btn-container">
              <div class="btn-content">
                  <a href="https://ades.eaufrance.fr/Fiche/PtEau?Code={{identifier}}" target="_blank">
                    {{ 'HEADBAND.MODELE.MODAL.GRAPH.LINK-ADES' | translate }}
                  </a>
              </div>
              <div class="btn-content">
                <a (click)="exportChart()">
                  {{ 'HEADBAND.MODELE.MODAL.GRAPH.LINK-PNG' | translate }}
                </a>
              </div>
          </div>
        </p-overlayPanel>
      </div>
    </div>

    <div class="chart-toolbar">
      <p-button [icon]="modeZoom ? 'pi pi-arrows-alt' : 'pi pi-search'" severity="secondary" (onClick)="setModeZoom()" />
      <p-button icon="pi pi-refresh" severity="secondary" (onClick)="resetZoomBtn()" />
    </div>
    
    <div class="chart-container">
      <canvas id="chartRealtimeModel"></canvas>
      <div *ngIf="loading" class="loading-content">
          <fa-icon [icon]="faSpinner"></fa-icon>
          <div>{{ 'HEADBAND.MODELE.MODAL.LOADING_MODAL' | translate }}</div>
      </div>
    </div>
    
  </div>
  